import * as yup from "yup";

export const informativeVideoSchema = yup.object().shape({
  videoTitle: yup.string(),
  videoBranding: yup.string(),
  videoScript: yup.string(),
  videoThumbnail: yup.string(),
  videoDescription: yup.string(),
  videoDriveLink: yup.string(),
  videoCredit: yup.string(),
  cameraName: yup.string(),
  markAsPublished: yup.string(),
  videoLanguage: yup.string(),
  videoVenue: yup.string(),
  shootingDate: yup.string(),
  rawFootagePath: yup.string(),
  videoEditor: yup.string(),
  commingSoonPoster: yup.string(),
  videofirstPath: yup.string(),
  taskdedline: yup.string(),
});
